module.exports = __webpack_public_path__ + "img/givefeedbackicon.52b4bcc9.svg";